import React from "react";
import {
  Box,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Link,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import heatPumpImg1 from "./assets/hpPVT.jpg";
import heatPumpImg2 from "./assets/hp_bhe.jpg";
import heatPumpImg3 from "./assets/hpPVTbhe.jpg";

const HomePage = ({ setActiveStep }) => {
  const navigate = useNavigate();

  const handleNavigate = (mode, step) => {
    if (setActiveStep) setActiveStep(step);
    navigate("/wpdesign", { state: { mode, step } });
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#f4f7fb",
        p: 4,
      }}
    >
      <Typography
        variant="h3"
        sx={{
          mb: 2,
          fontWeight: 400,
          color: "primary.main",
          textAlign: "center",
          py: 10,
        }}
      >
        Willkommen zum Design-Tool für Dimensionierung der
        PVT-Wärmepumpensysteme
      </Typography>
      <Typography
        variant="h6"
        sx={{ mb: 6, color: "text.secondary", textAlign: "center" }}
      >
        Dieses interaktive Tool unterstützt Sie bei der Dimensionierung von
        PVT-Kollektoren, Wärmepumpen und Erdwärmesonden basierend auf Ihren
        individuellen Projektparametern. Wählen Sie einen Bereich, um mit der
        Planung zu beginnen.
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {/* Merged Card */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              width: 550,
              height: 550,
              mx: "auto",
              boxShadow: 6,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardActionArea
              component="div"
              onClick={() => handleNavigate("PVT_ONLY", 1)}
              sx={{
                flexGrow: 1,
                p: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: 420, height: 270, objectFit: "cover" }}
                  image={heatPumpImg1}
                  alt="Heat Pump System"
                />
              </Box>

              <CardContent
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  mt: 2,
                }}
              >
                <Box>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: 600, textAlign: "center" }}
                  >
                    Wärmepumpensysteme mit PVT-Kollektoren
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: "center" }}
                  >
                    Starten Sie die kombinierte Auslegung der Wärmepumpe und der
                    PVT-Kollektoren.
                  </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                  <Box
                    component="div"
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white",
                      px: 2,
                      py: 1,
                      borderRadius: 1,
                      fontWeight: 500,
                      textAlign: "center",
                      width: "100%",
                      cursor: "pointer",
                    }}
                  >
                    Auslegung starten
                  </Box>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* bhe Card */}
        <Grid item xs={12} md={6}>
          <Card
            sx={{
              width: 550,
              height: 550,
              mx: "auto",
              boxShadow: 6,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardActionArea
              component="div"
              onClick={() => handleNavigate("PVT_BHE", 3)}
              sx={{
                flexGrow: 1,
                p: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 2,
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: 400, height: 290, objectFit: "cover" }}
                  image={heatPumpImg2}
                  alt="BHE"
                />
              </Box>

              <CardContent
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: 600, textAlign: "center" }}
                  >
                    Wärmepumpensysteme mit Erdwärmesonden
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: "center" }}
                  >
                    Starten Sie der Auslegung der Erdwärmesonden nach VDI 4640.
                  </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                  <Box
                    component="div"
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white",
                      px: 2,
                      py: 1,
                      borderRadius: 1,
                      fontWeight: 500,
                      textAlign: "center",
                      width: "100%",
                      cursor: "pointer",
                    }}
                  >
                    Auslegung starten
                  </Box>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>

        {/* EWS Card */}
        {/* <Grid item xs={12} md={4}>
          <Card
            sx={{
              width: 550,
              height: 550,
              mx: "auto",
              boxShadow: 6,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <CardActionArea
              component="div"
              onClick={() => handleNavigate("PVT_BHE", 3)}
              sx={{
                flexGrow: 1,
                p: 2,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  mb: 2,
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: 400, height: 290, objectFit: "cover" }}
                  image={heatPumpImg3}
                  alt="BHE"
                />
              </Box>

              <CardContent
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <Box>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    sx={{ fontWeight: 600, textAlign: "center" }}
                  >
                    Wärmepumpensysteme mit PVT-Kollektoren und Erdwärmesonden
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: "center" }}
                  >
                    Starten Sie der Auslegung der Erdwärmesonden nach VDI 4640.
                  </Typography>
                </Box>

                <Box sx={{ mt: 3 }}>
                  <Box
                    component="div"
                    sx={{
                      backgroundColor: "primary.main",
                      color: "white",
                      px: 2,
                      py: 1,
                      borderRadius: 1,
                      fontWeight: 500,
                      textAlign: "center",
                      width: "100%",
                      cursor: "pointer",
                    }}
                  >
                    Auslegung starten
                  </Box>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid> */}
      </Grid>
      {/* Footer */}
      <Box sx={{ mt: "auto", mb: 3, textAlign: "center" }}>
        <Grid sx={{ my: 3 }} />

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ opacity: 0.8, py: 10 }}
        >
          <Link
            href="https://isfh.de/impressum"
            underline="hover"
            color="inherit"
          >
            Impressum
          </Link>{" "}
          |{" "}
          <Link href="https://isfh.de/agb" underline="hover" color="inherit">
            AGB
          </Link>{" "}
          |{" "}
          <Link
            href="https://isfh.de/barrierefreiheit"
            underline="hover"
            color="inherit"
          >
            Barrierfreiheit
          </Link>{" "}
          | © {new Date().getFullYear()} Institut für Solarenergieforschung GmbH
        </Typography>
      </Box>
    </Box>
  );
};

export default HomePage;
